import { ArrowLeft, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { set } from 'react-hook-form';
import { Link } from 'react-router-dom';

const categories = [
  {
    title: 'Home & Living',
    items: [
      { name: 'Decor', icon: '/images/decor.svg', link: '/home-living/decor' },
      {
        name: 'Furniture',
        icon: '/images/furniture.svg',
        link: '/home-living/furniture',
      },
      {
        name: 'Bed & Bath',
        icon: '/images/bed.svg',
        link: '/home-living/bed-bath',
      },
      {
        name: 'Kitchen & Dining',
        icon: '/images/kitchen.svg',
        link: '/home-living/kitchen-dining',
      },
      {
        name: 'Garden & Outdoor',
        icon: '/images/garden.svg',
        link: '/home-living/garden-outdoor',
      },
      {
        name: 'Home Improvement',
        icon: '/images/home.svg',
        link: '/home-living/home-improvement',
      },
    ],
  },
  {
    title: 'Lifestyle & Consumer goods',
    items: [
      {
        name: 'Personal care',
        icon: '/images/personal.svg',
        link: '/lifestyle-consumer-goods/personal-care',
      },
      {
        name: 'Toys',
        icon: '/images/toys.svg',
        link: '/lifestyle-consumer-goods/toys',
      },
      {
        name: 'Beauty',
        icon: '/images/beauty.svg',
        link: '/lifestyle-consumer-goods/beauty',
      },
      {
        name: 'Fashion',
        icon: '/images/fashion.svg',
        link: '/lifestyle-consumer-goods/fashion',
      },
      {
        name: 'Household essentials',
        icon: '/images/household.svg',
        link: '/lifestyle-consumer-goods/household-essentials',
      },
      {
        name: 'Entertainment',
        icon: '/images/entertainment.svg',
        link: '/lifestyle-consumer-goods/entertainment',
      },
      {
        name: 'Books',
        icon: '/images/books.svg',
        link: '/lifestyle-consumer-goods/books',
      },
      {
        name: 'Baby&Mother care',
        icon: '/images/baby.svg',
        link: '/lifestyle-consumer-goods/baby-mother-care',
      },
      {
        name: 'Health&wellness',
        icon: '/images/health.svg',
        link: '/lifestyle-consumer-goods/health-wellness',
      },
    ],
  },
  {
    title: 'Electronics',
    items: [
      {
        name: 'Phones',
        icon: '/images/phone.svg',
        link: '/electronics/phones',
      },
      {
        name: 'Computers',
        icon: '/images/computers.svg',
        link: '/electronics/computers',
      },
      { name: 'TV', icon: '/images/tv.svg', link: '/electronics/tv' },
      {
        name: 'Home Appliances',
        icon: '/images/home-appliances.svg',
        link: '/electronics/home-appliances',
      },
      {
        name: 'Gadgets',
        icon: '/images/gadgets.svg',
        link: '/electronics/gadgets',
      },
      {
        name: 'Accessories',
        icon: '/images/accessories.svg',
        link: '/electronics/accessories',
      },
      {
        name: 'Home audio&Theater',
        icon: '/images/audio.svg',
        link: '/electronics/home-audio-theater',
      },
      {
        name: 'Video games',
        icon: '/images/games.svg',
        link: '/electronics/video-games',
      },
    ],
  },
  {
    title: 'Food & Drink',
    items: [
      {
        name: 'Grocery',
        icon: '/images/grocery.svg',
        link: '/food-drink/grocery',
      },
      {
        name: 'Confectionery',
        icon: '/images/confectionery.svg',
        link: '/food-drink/confectionery',
      },
      {
        name: 'Beverage',
        icon: '/images/beverages.svg',
        link: '/food-drink/beverages',
      },
    ],
  },
  // {
  //   title: 'Real Estate',
  //   items: [
  //     { name: 'RentSmallSmall', link: '/real-estate/rentSmallSmall' },
  //     { name: 'StaySmallSmall', link: '/real-estate/staySmallSmall' },
  //     { name: 'BuySmallSmall', link: '/real-estate/buySmallSmall' },
  //   ],
  // },
];

const Shop = ({ isOpen, onClose, setHamburgerIsOpen, setShopIsOpen }) => {
  const [visible, setVisible] = useState(false);

  const handleClose = () => {
    setShopIsOpen(false);
    setHamburgerIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
    } else {
      const timer = setTimeout(() => setVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!visible && !isOpen) return null;

  return (
    <div className="fixed inset-0 z-50">
      {/* Backdrop */}
      <div
        className={`absolute inset-0 bg-black transition-opacity duration-300 ${
          isOpen ? 'opacity-50' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => onClose(false)}
      />

      <div
        className={`absolute top-0 left-0 w-full h-full bg-white transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Close (X) */}
        <div className="flex justify-end px-4 pt-6">
          <button onClick={() => onClose(false)}>
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Category Links */}
        <div className="px-4 py-4 space-y-6 overflow-y-auto h-[calc(100%-100px)]">
          {categories.map((group) => (
            <div key={group.title}>
              <h3 className="text-base font-semibold text-gray-700 mb-2">
                {group.title}
              </h3>
              <div className="flex flex-wrap gap-2">
                {group.items.map((item) => (
                  <Link
                    key={item.name}
                    to={item.link}
                    onClick={handleClose}
                    className="flex w-fit space-x-2 items-center justify-center px-4 py-2 rounded-full text-sm bg-[#F5F5F7] hover:bg-gray-200 transition whitespace-nowrap"
                  >
                    {item.icon && (
                      <img
                        src={item.icon}
                        alt={item.name}
                        className="w-[30px] h-[30px] mr-1"
                      />
                    )}
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>
          ))}

          {/* Back button → reopen hamburger */}
          <div className="pt-8">
            <button
              onClick={() => onClose(true)}
              className="flex items-center text-sm"
            >
              <ArrowLeft className="w-4 h-4 mr-1" />
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Shop;
